import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface TaskFilters {
  employee: string[];
  modules: string[];
  features: string[];
  projects: string[];
}

@Component({
  selector: 'app-pms-filter-dropdown',
  templateUrl: './pms-filter-dropdown.component.html',
  styleUrls: ['./pms-filter-dropdown.component.scss']
})
export class PMSFilterDropdownComponent {

  @Input() employees: any[] = [];
  @Input() modules: any[] = [];
  @Input() features: any[] = [];
  @Input() projects: any[] = [];

  @Input() taskFilters!: TaskFilters;
  @Output() selectionChanged = new EventEmitter<{ type: string; id: string }>();

  employeeFilter = '';
  moduleFilter = '';
  featureFilter = '';
  projectFilter = '';

  selectedEmployeeId: number | null = null;
  selectedModuleId: number | null = null;
  selectedFeatureId: number | null = null;
  selectedProjectId: number | null = null;

  employeeFilterKeys = ['firstName', 'userName'];
  moduleFilterKeys = 'title';
  featureFilterKeys = 'title';
  projectFilterKeys = 'title';

  selectEmployee(emp: any) {
    this.selectedEmployeeId = emp.id.toString();
    this.selectionChanged.emit({ type: 'employee', id: emp.id.toString() });
  }

  selectModule(mod: any) {
    this.selectedModuleId = mod.id.toString();
    this.selectionChanged.emit({ type: 'module', id: mod.id.toString() });
  }

  selectFeature(feat: any) {
    this.selectedFeatureId = feat.id.toString();
    this.selectionChanged.emit({ type: 'feature', id: feat.id.toString() });
  }

  selectProject(proj: any) {
    this.selectedProjectId = proj.id.toString();
    this.selectionChanged.emit({ type: 'project', id: proj.id.toString() });
  }

  passToOtherComponent(id: number, type: string) {
    this.selectionChanged.emit({ type, id: id.toString() });
  }

}
